<template>
  <div
    class="asset-thumb"
    @click="handleClick"
    :title="title"
    role="button"
    tabindex="0"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick">
    <v-img
      v-if="src"
      cover
      :src="src"
      class="preview-image" />
    <div
      v-else
      class="placeholder-label">
      {{ label || 'Asset' }}
    </div>
    <v-icon
      size="large"
      class="quick-edit-icon">
      {{ icon }}
    </v-icon>
  </div>
</template>

<script setup>
const props = defineProps({
  src: String,
  label: String,
  icon: { type: String, default: 'mdi-pencil-circle' },
  title: { type: String, default: '' },
});
const emit = defineEmits(['click']);
function handleClick() {
  emit('click');
}
</script>

<style scoped>
.asset-thumb {
  position: relative;
  /* revert to original smaller size (~16:9) */
  width: 90px;
  height: 56px;
  min-width: 90px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  display: inline-block;
  flex: 0 0 auto; /* prevent shrinking inside flex */
  margin-right: 8px; /* restore spacing between thumb and dropdown */
  background-color: var(--v-theme-surface, #eee);
  background-position: center;
  background-size: cover;
}

.preview-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: opacity 0.18s ease;
}

.placeholder-label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(0, 0, 0, 0.3);
  text-align: center;
  padding: 4px;
  word-break: break-word;
  line-height: 1.2;
}

.quick-edit-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  opacity: 0;
  transition:
    opacity 0.12s ease,
    transform 0.12s ease;
  z-index: 20;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 6px;
  pointer-events: none; /* allow click to pass through to container */
  font-size: 18px;
}

.asset-thumb:hover .preview-image {
  opacity: 0.55;
}

.asset-thumb:hover .quick-edit-icon {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1.05);
}

.asset-thumb:focus-visible {
  outline: 2px solid rgba(100, 150, 250, 0.6);
}
</style>
